import { forwardRef } from 'react';

import { Input } from '@/components/ui/input';
import { CurrencyCode, currencies } from '@/lib/consts';
import { cn } from '@/lib/utils';

interface CurrencyInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  currencyCode: CurrencyCode;
}

export const CurrencyInput = forwardRef<HTMLInputElement, CurrencyInputProps>(
  ({ className, currencyCode, onChange, ...props }, ref) => {
    const currency = currencies[currencyCode];

    const preChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      // Allow empty value, digits only, or digits with up to 2 decimal places
      if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
        onChange?.(e);
      }
    };

    return (
      <div className="space-y-2">
        <div className="relative">
          <Input
            type="text"
            min={0}
            className={cn('pl-8', className)}
            ref={ref}
            {...props}
            onChange={preChangeHandler}
          />
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
            <span className="text-muted-foreground text-sm font-medium">
              {currency.symbol}
            </span>
          </div>
        </div>
      </div>
    );
  },
);
CurrencyInput.displayName = 'CurrencyInput';
